import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Layout } from "../components/Layout";
import { useAuth } from "../context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const AdminLogin = () => {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin/new", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin/new", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-20">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-full border-2 border-[#9E4535] flex items-center justify-center text-[#9E4535] mb-5">
            <Lock className="w-6 h-6" />
          </div>
          <p className="caption-label mb-2">Restricted</p>
          <h1 className="font-serif-display text-3xl font-bold text-[#1A1615]">Curator Access</h1>
          <p className="font-body text-sm text-[#4A4036] mt-2">Sign in to catalogue new curiosities.</p>
        </div>

        <form onSubmit={submit} className="bg-white border border-[#D8CEB9] rounded-sm p-7 space-y-4">
          <div>
            <label className="caption-label block mb-1.5">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full font-ui text-sm px-3 py-2.5 bg-[#FAF7F0] border border-[#D8CEB9] rounded-sm outline-none focus:border-[#9E4535] focus:ring-2 focus:ring-[#F5E8EA]"
            />
          </div>
          <div>
            <label className="caption-label block mb-1.5">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full font-ui text-sm px-3 py-2.5 bg-[#FAF7F0] border border-[#D8CEB9] rounded-sm outline-none focus:border-[#9E4535] focus:ring-2 focus:ring-[#F5E8EA]"
            />
          </div>
          {error && <p className="font-ui text-sm text-[#9E4535]" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full font-ui text-sm font-semibold py-3 bg-[#9E4535] text-[#FAF7F0] rounded-sm hover:bg-[#82382B] transition-colors disabled:opacity-60"
          >
            {loading ? "Unlocking…" : "Enter the Vault"}
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default AdminLogin;
